import { motion, useReducedMotion } from "framer-motion";
import * as React from "react";
import { SLOGAN } from "@/lib/branding";
import { cn } from "@/lib/utils";

interface SloganProps {
  /** Words slide in one after another. */
  animated?: boolean;
  /** Seconds before the first word appears. */
  delay?: number;
  className?: string;
}

const WORDS = SLOGAN.replace(/^\.\./, "").replace("'", "’").split(" ");
const ease = [0.22, 1, 0.36, 1] as const;

/** “..but a Deck ain't one”: quotes and lead dots upright, the words in italic. */
export function Slogan({ animated = false, delay = 0, className }: SloganProps) {
  const reduceMotion = useReducedMotion();
  const play = animated && !reduceMotion;
  const token = (index: number) =>
    play
      ? {
          initial: { opacity: 0, x: -28, y: 10, filter: "blur(8px)" },
          animate: { opacity: 1, x: 0, y: 0, filter: "blur(0px)" },
          transition: { delay: delay + index * 0.14, duration: 0.7, ease },
        }
      : {};

  return (
    <span className={cn("brand-slogan", className)}>
      <span className="sr-only">“{SLOGAN}”</span>
      <motion.span aria-hidden="true" className="brand-slogan-mark" {...token(0)}>
        “..
      </motion.span>
      {WORDS.map((word, index) => (
        <React.Fragment key={word}>
          {index > 0 && " "}
          <motion.span aria-hidden="true" className="brand-slogan-word" {...token(index + 1)}>
            {word}
            {index === WORDS.length - 1 && <span className="brand-slogan-mark">”</span>}
          </motion.span>
        </React.Fragment>
      ))}
    </span>
  );
}
